import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import { isAllowedUploadDocument } from './uploadValidation';
export const CustomPagination = ({rowsPerPage, rowCount, currentPage, onChangePage}) => {
    const totalPages = Math.ceil(rowCount / rowsPerPage);
    const pageNumbers = Array.from({length: totalPages}, (_, i) => i + 1);

    const paginationNumber = () => {
        if (pageNumbers.length <= 5) {
            return pageNumbers;
        } else if (pageNumbers.length >= 5 && currentPage <= 4) {
            return [1, 2, 3, 4, 5, '...', pageNumbers[pageNumbers.length - 1]];
        } else if (pageNumbers.length >= 5 && currentPage >= pageNumbers[pageNumbers.length - 4]) {
            return [1, '...', pageNumbers[pageNumbers.length - 5], pageNumbers[pageNumbers.length - 4], pageNumbers[pageNumbers.length - 3], pageNumbers[pageNumbers.length - 2], pageNumbers[pageNumbers.length - 1]];
        } else if (pageNumbers.length > 5 && currentPage > 4 && currentPage < pageNumbers[pageNumbers.length - 4]) {
            return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', pageNumbers[pageNumbers.length - 1]];
        }
    };
    let paginationItms = paginationNumber();

    return (
        <div className='pt-3'>
            <span className='pb-2'>Total Rows: <b>{rowCount}</b></span>
            <Pagination className='mt-2'>
                {paginationItms.map((pageNumber, i) => (
                    <Pagination.Item
                        key={i}
                        onClick={() => onChangePage(pageNumber)}
                        disabled={(isNaN(pageNumber))}
                        active={(currentPage === pageNumber)}
                    >
                        {pageNumber}
                    </Pagination.Item>
                ))}
            </Pagination>
        </div>
    );
};


export const AddCommasToAmount = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '';

    const rawDivisor = localStorage.getItem('globalAmountDivisor') || '1';
    const divisor = Number(rawDivisor) || 1;

    const raw = String(amount).replace(/,/g, '').trim();
    const num = Number(raw);
    if (Number.isNaN(num)) return String(amount);

    const formatWithCommas = (value) => {
        const [integerPart, decimalPart] = String(value).split('.');
        const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
    };

    if (divisor === 1) {
        return formatWithCommas(raw);
    }

    const suffixMap = {
        1000: 'K',
        100000: 'L',
        10000000: 'Cr',
    };
    const suffix = suffixMap[divisor] || '';

    const scaled = num / divisor;
    const absScaled = Math.abs(scaled);
    const fractionDigits = absScaled >= 100 ? 0 : absScaled >= 10 ? 1 : 2;

    const scaledText = scaled.toLocaleString('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: fractionDigits,
    });

    return `${scaledText}${suffix}`;
}

const INVOICE_DEDUCTION_FIELDS = [
    { key: 'tds_it_amount', label: 'TDS IT' },
    { key: 's_gst_amount', label: 'SGST' },
    { key: 'c_gst_amount', label: 'CGST' },
    { key: 'i_gst_amount', label: 'IGST' },
    { key: 'royalty_amount', label: 'Royalty' },
    { key: 'labour_amount', label: 'Labour' },
    { key: 'other_deduction', label: 'Other' },
    { key: 'penalty_amount', label: 'Penalty' },
    { key: 'withheld_amount', label: 'Withheld' },
];

export const getActiveInvoiceDeductions = (details) => {
    if (!details || typeof details !== 'object') {
        return [];
    }

    return INVOICE_DEDUCTION_FIELDS.reduce((items, { key, label }) => {
        const rawValue = details[key];
        if (rawValue == null || rawValue === '') {
            return items;
        }

        const numericValue = Number(String(rawValue).replace(/,/g, '').trim());
        if (Number.isNaN(numericValue) || numericValue === 0) {
            return items;
        }

        items.push({
            key,
            label,
            amount: AddCommasToAmount(rawValue),
        });
        return items;
    }, []);
};


export const numberToWords = (num) => {
    if (num === 0) {
        return 'zero';
    }

    const units = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    const teens = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    const getWordsForTwoDigitNumber = (num) => {
        if (num >= 11 && num <= 19) {
            return teens[num - 11];
        } else {
            const ten = Math.floor(num / 10);
            const remainder = num % 10;
            return (tens[ten] + (remainder !== 0 ? ' ' + units[remainder] : '')).trim();
        }
    };

    // Remove commas and convert to a number
    num = Number(num.replace(/,/g, ''));

    const numArray = Array.from(String(num), Number);
    let result = '';

    // Handle millions
    if (numArray.length > 6) {
        result += `${units[numArray[0]]} million `;
        numArray.shift();
    }

    // Handle thousands
    if (numArray.length > 3) {
        result += `${units[numArray[0]]} thousand `;
        numArray.shift();
    }

    // Handle hundreds
    if (numArray.length > 2 && numArray[0] !== 0) {
        result += `${units[numArray[0]]} hundred `;
        numArray.shift();
    }

    // Handle remaining two digits
    const twoDigitNumber = parseInt(numArray.join(''), 10);
    const wordsForTwoDigitNumber = getWordsForTwoDigitNumber(twoDigitNumber);
    result += wordsForTwoDigitNumber;

    return result.trim();
}

export const get_file_ext = (file_url) => {
    if (file_url) {
        try {
            const parsedUrl = new URL(file_url);
            const pathname = parsedUrl.pathname;
            const fileType = pathname.split('.').pop();
            return fileType;
        } catch (error) {
            return null;
        }
    } else {
        return null;
    }
}

export const isValidURL = (v) =>
    /^(https?:\/\/)([\w.-]+)(:[0-9]+)?(\/[^\n\s]*)?$/i.test(v);

export const TRUSTED_DOCUMENT_HOSTS = [
    'tangy-media-sms.s3.ap-south-1.amazonaws.com',
    'tangy-media-sms.s3.amazonaws.com',
];

export const TRUSTED_REDIRECT_HOSTS = [
    'prod.smartauth.co',
    'smartauth.co',
    'www.smartauth.co',
];

export const getSafeRedirectUrl = (url, allowedHosts = TRUSTED_REDIRECT_HOSTS) => {
    if (!url || typeof url !== 'string') {
        return null;
    }

    const trimmedUrl = url.trim();
    if (!trimmedUrl) {
        return null;
    }

    try {
        const parsedUrl = new URL(trimmedUrl);
        const lowerHref = parsedUrl.href.toLowerCase();

        if (parsedUrl.protocol !== 'https:') {
            return null;
        }

        if (lowerHref.includes('javascript:') || lowerHref.startsWith('data:')) {
            return null;
        }

        if (parsedUrl.username || parsedUrl.password) {
            return null;
        }

        if (!allowedHosts.includes(parsedUrl.hostname)) {
            return null;
        }

        return parsedUrl.href;
    } catch (error) {
        return null;
    }
};

export const openSafeRedirectUrl = (url, allowedHosts = TRUSTED_REDIRECT_HOSTS) => {
    const safeUrl = getSafeRedirectUrl(url, allowedHosts);
    if (!safeUrl) {
        return false;
    }

    const newWindow = window.open(safeUrl, '_blank', 'noopener,noreferrer');
    if (newWindow) {
        try {
            newWindow.opener = null;
        } catch (error) {
            // ignore
        }
    }

    return Boolean(newWindow);
};

export const getSafeDocumentUrl = (url, allowedHosts = TRUSTED_DOCUMENT_HOSTS) => {
    if (!url || typeof url !== 'string') {
        return null;
    }

    const trimmedUrl = url.trim();
    if (!trimmedUrl) {
        return null;
    }

    try {
        const parsedUrl = new URL(trimmedUrl, window.location.origin);
        const lowerHref = parsedUrl.href.toLowerCase();

        if (parsedUrl.protocol !== 'https:' && parsedUrl.protocol !== 'http:') {
            return null;
        }

        if (lowerHref.includes('javascript:') || lowerHref.startsWith('data:text/html')) {
            return null;
        }

        const isSameOrigin = parsedUrl.origin === window.location.origin;
        const isAllowedHost = allowedHosts.includes(parsedUrl.hostname);

        if (!isSameOrigin && parsedUrl.protocol !== 'https:') {
            return null;
        }

        if (!isSameOrigin && !isAllowedHost) {
            return null;
        }

        return parsedUrl.href;
    } catch (error) {
        return null;
    }
};

export const openSafeDocumentUrl = (url, allowedHosts = TRUSTED_DOCUMENT_HOSTS) => {
    const safeUrl = getSafeDocumentUrl(url, allowedHosts);
    if (!safeUrl) {
        return false;
    }

    window.open(safeUrl, '_blank', 'noopener,noreferrer');
    return true;
};

export const downloadSafeFile = (url, filename = '', allowedHosts = TRUSTED_DOCUMENT_HOSTS) => {
    const safeUrl = getSafeDocumentUrl(url, allowedHosts);
    if (!safeUrl) {
        return false;
    }

    const link = document.createElement('a');
    link.href = safeUrl;
    if (filename) {
        link.download = filename;
    }
    link.rel = 'noopener noreferrer';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
};

/** Parse filename from Content-Disposition header. */
export const parseFilenameFromContentDisposition = (header, fallback = 'download.xlsx') => {
    if (!header) {
        return fallback;
    }
    const utfMatch = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header);
    if (utfMatch?.[1]) {
        try {
            return decodeURIComponent(utfMatch[1].trim().replace(/"/g, ''));
        } catch (e) {
            return utfMatch[1].trim().replace(/"/g, '');
        }
    }
    const match = /filename\s*=\s*"([^"]+)"|filename\s*=\s*([^;]+)/i.exec(header);
    if (match) {
        return (match[1] || match[2] || '').trim().replace(/"/g, '') || fallback;
    }
    return fallback;
};

/**
 * Save an authenticated axios blob response as a file.
 * Throws Error with backend message if the blob is actually a JSON error body.
 */
export const downloadAuthBlobResponse = async (response, fallbackFilename = 'download.xlsx') => {
    const data = response?.data;
    const contentType = String(response?.headers?.['content-type'] || data?.type || '').toLowerCase();

    if (data instanceof Blob && (contentType.includes('application/json') || contentType.includes('text/json'))) {
        const text = await data.text();
        let message = 'Export failed';
        try {
            const json = JSON.parse(text);
            message = json?.message || message;
        } catch (e) {
            // keep default
        }
        throw new Error(message);
    }

    const filename = parseFilenameFromContentDisposition(
        response?.headers?.['content-disposition'],
        fallbackFilename
    );

    const blob = data instanceof Blob
        ? data
        : new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(objectUrl);
};

/** Read error message from axios error when responseType was blob. */
export const getBlobErrorMessage = async (error, fallback = 'Something went wrong') => {
    const data = error?.response?.data;
    if (data instanceof Blob) {
        try {
            const text = await data.text();
            const json = JSON.parse(text);
            return json?.message || fallback;
        } catch (e) {
            return fallback;
        }
    }
    return error?.response?.data?.message || error?.message || fallback;
};

export const isSafeObjectKey = (key) => {
    // Disallow prototype-polluting keys and suspicious patterns
    if (!key || typeof key !== 'string') return false;
    const forbidden = ['__proto__', 'prototype', 'constructor'];
    if (forbidden.includes(key)) return false;
    if (key.includes('.') || key.includes('[') || key.includes(']')) return false;
    return true;
}

export const get_file_url_last_name = (file_url) => {
    if (file_url) {
        try {

            const filename = file_url.split('/').pop();
            return filename;
        } catch (error) {
            return '';
        }
    } else {
        return '';
    }
}

export const show_l1_action_btn = (user_type, l2_status, l3_status, is_default = 0) => {
    if (user_type == 'l1' && is_default == 0) {
        if (l2_status == 1 || l3_status == 1) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}


export const show_l1_action_btn_view = (user_type, l2_status, l3_status) => {
    if (user_type == 'l2') {
        if (l3_status == 2) {
            return false;
        } else {
            return true;
        }
    }
    if (user_type == 'l3') {
        if (l2_status == 2) {
            return false;
        } else {
            return true;
        }
    } else {
        return true;
    }
}


export const show_challan_edit_btn = (user_type, l2_status, l3_status) => {
    if (user_type == 'l1') {
        if ((l2_status == 0 || l3_status == 0)) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

export const show_invoice_edit_btn = (user_type, l2_status, l3_status) => {
    if (user_type == 'l1') {
        if ((l2_status == 2 || l3_status == 2)) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

export const check_is_equal_sanction_voucher_amount = (sanction_value, voucher_value_arr) => {
    if (sanction_value && voucher_value_arr) {
        sanction_value = parseInt(sanction_value);
        let total_voucher_value = 0;
        voucher_value_arr.forEach(voucher => {
            total_voucher_value += parseInt(voucher.total_voucher_value);
        });
        if (sanction_value == total_voucher_value) {
            return true;
        } else {
            return false;
        }
    } else {
        return true;
    }
}
export const check_is_equal_sanction_subhead_amount = (sanction_value, subheadArray) => {
    if (sanction_value && subheadArray) {
        sanction_value = parseInt(sanction_value);
        let total_subhead_value = 0;
        subheadArray.forEach(subhead => {
            total_subhead_value += parseInt(subhead.sub_head_amount);
        });
        if (sanction_value<total_subhead_value) {
            return true;
        } else {
            return false;
        }
    } else {
        return true;
    }
}

export const check_is_equal_voucher_invoices_amount = (voucher_value, invoice_value_arr) => {
    if (voucher_value && invoice_value_arr) {
        voucher_value = parseInt(voucher_value);
        let total_invoice_value = 0;
        invoice_value_arr.forEach(invoice => {
            total_invoice_value += parseInt(invoice.sanction_amount);
        });
        if (voucher_value == total_invoice_value) {
            return true;
        } else {
            return false;
        }
    } else {
        return true;
    }
}


export const check_is_equal_sanctioned_and_schemes_amount = (sanction_amount, scheme_amount_arr) => {
    if (sanction_amount && scheme_amount_arr) {
        sanction_amount = parseInt(sanction_amount);
        let total_scheme_amount = 0;
        scheme_amount_arr.forEach(scheme => {
            total_scheme_amount += parseInt(scheme.amount);
        });
        if (sanction_amount == total_scheme_amount) {
            return true;
        } else {
            return false;
        }
    } else {
        return true;
    }
}


export const isFilePdf_or_Image = (file) => {
    // Shared whitelist: pdf, jpg, jpeg, png — max 5MB (see uploadValidation.js / MALICIOUS_FILE_UPLOAD.md)
    return isAllowedUploadDocument(file);
};


export const goback = () => {
    window.history.back();
}

export const get_schemes_entered_amount = (formData) => {

    const schemeAmounts = {};
    for (const voucher of formData.vouchers) {
        for (const invoice of voucher.invoices) {
            for (const scheme of invoice.schemes) {
                const schemeId = scheme.scheme_id;
                const amount = parseInt(scheme.amount);
                if (schemeId && amount >= 0) {
                    if (!schemeAmounts[schemeId+"|"+scheme.financial_year]) {
                        schemeAmounts[schemeId+"|"+scheme.financial_year] = {totalAmount: 0, subheads: {}};
                    }
                    schemeAmounts[schemeId+"|"+scheme.financial_year].totalAmount += amount;
                    for (const subhead of scheme.subheads) {
                        // console.log(subhead)
                        if (subhead) {
                            let subHeadsId = subhead.sub_heads_id;
                            // console.log(subHeadsId)
                            const subHeadAmount = parseInt(subhead.sub_head_amount);
                            if (!subHeadsId || subHeadsId == 'NaN') {
                                subHeadsId = 0
                            }
                            // console.log(subHeadsId,subHeadAmount)
                            if (subHeadsId && subHeadAmount >= 0) {
                                if (!schemeAmounts[schemeId+"|"+scheme.financial_year].subheads[subHeadsId]) {
                                    schemeAmounts[schemeId+"|"+scheme.financial_year].subheads[subHeadsId] = 0;
                                }
                                schemeAmounts[schemeId+"|"+scheme.financial_year].subheads[subHeadsId] += subHeadAmount;
                            }
                        }
                    }
                }
            }
        }
    }
    // console.log(schemeAmounts)
    return schemeAmounts;
}

export const get_schemes_entered_amount_in_edit_invoice = (formData) => {

    const schemeAmounts = {};
    for (const scheme of formData.schemes) {
        const schemeId = scheme.scheme_id;
        const amount = parseInt(scheme.amount);
        if (schemeId && amount >= 0) {
            if (!schemeAmounts[schemeId]) {
                schemeAmounts[schemeId] = {totalAmount: 0, subheads: {}};
            }
            schemeAmounts[schemeId].totalAmount += amount;

            for (const subhead of scheme.subheads) {
                // console.log(subhead)
                if (subhead) {
                    let subHeadsId = subhead.sub_heads_id;
                    // console.log(subHeadsId)
                    const subHeadAmount = parseInt(subhead.sub_head_amount);
                    if (!subHeadsId || subHeadsId == 'NaN') {
                        subHeadsId = 0
                    }
                    // console.log(subHeadsId,subHeadAmount)
                    if (subHeadsId && subHeadAmount >= 0) {
                        if (!schemeAmounts[schemeId].subheads[subHeadsId]) {
                            schemeAmounts[schemeId].subheads[subHeadsId] = 0;
                        }
                        schemeAmounts[schemeId].subheads[subHeadsId] += subHeadAmount;
                    }
                }
            }
        }
    }
    // console.log(schemeAmounts)
    return schemeAmounts;
}
